import * as React from "react";

import "./existing-order-session-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {DeprecatedModalService2}   from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const ExistingOrderSessionModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => <DeprecatedModalService2 {...{
        render: ({onSelect, existingOrderSessionInfo}, rm) => ({
            content: next({
                existingOrderSessionInfo,
                onSelect: (result) => {
                    onSelect(result);
                    rm();
                },
            }),
        }),
        next: rootNext,
    }}/>],
    consumeContext("themeScheme"),
    ({modal: {existingOrderSessionInfo, onSelect}, themeScheme}) => (
        <div className="existing-order-session-modal-18w">
            <div className="title" style={{color: themeScheme.xpresso.menuBackgroundColor}}>
                Existing Order in Customization
            </div>

            <div className="description">
                The following order is still in the customization process:
            </div>
            <div className="info">
                <div className="label">Order Name:</div>
                <div className="value">{existingOrderSessionInfo.orderName}</div>
                <div className="label">Template Name:</div>
                <div className="value">{existingOrderSessionInfo.templateName}</div>
                <div className="label">Product Name:</div>
                <div className="value">{existingOrderSessionInfo.productName}</div>
            </div>

            <div className="question">
                Would you like to use this template for the Existing Order or Start a New Order?
            </div>

            <div className="buttons">
                <button xd-qa-type="button" xd-qa-name="USE EXISTING ORDER" onClick={() => onSelect(false)}>USE EXISTING ORDER</button>
                <button xd-qa-type="button" xd-qa-name="START A NEW ORDER" onClick={() => onSelect(true)}>START A NEW ORDER</button>
            </div>
        </div>
    ),
);
